import { accountSelectedSelector } from 'atoms';
import dayjs from 'dayjs';
import React from 'react';
import { TFunction } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { ServiceOrderToPrint } from 'types/serviceOrder.types';
import { Column } from 'types/table.types';

function useServiceOrdersColumns({
  t,
}: {
  t: TFunction<('_common' | 'service_order')[], undefined>;
}): Column<ServiceOrderToPrint>[] {
  const accountSelected = useRecoilValue(accountSelectedSelector);
  return React.useMemo(() => {
    const descriptionColumn: Column<ServiceOrderToPrint> = {
      description: t('_common:service_order'),
      dataKey: 'description',
      renderValue: (value) => (value ? String(value) : t('_common:service_order')),
    };
    const accountCodeColumn: Column<ServiceOrderToPrint> = {
      description: t('_common:account'),
      dataKey: 'accountCode',
    };
    const stateColumn: Column<ServiceOrderToPrint> = {
      description: t('_common:state'),
      dataKey: 'status',
      // @ts-ignore
      renderValue: (status) => t(`service_order:${String(status)}`),
    };
    const dateColumn: Column<ServiceOrderToPrint> = {
      description: t('service_order:opening_date'),
      dataKey: 'date',
      renderValue: (date) => (date ? dayjs(date).format('L LTS') : ''),
    };
    const endDate: Column<ServiceOrderToPrint> = {
      description: t('service_order:closing_date'),
      dataKey: 'endDate',
      renderValue: (value) => (value ? dayjs(value).format('L LTS') : ''),
    };
    return accountSelected
      ? [descriptionColumn, stateColumn, dateColumn, endDate]
      : [descriptionColumn, accountCodeColumn, stateColumn, dateColumn, endDate];
  }, [accountSelected, t]);
}

export default useServiceOrdersColumns;
